module.exports = __webpack_public_path__ + "img/gold-onboard-bg.9ac6099f.svg";